"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionCreatedEvent = void 0;
const event_types_1 = require("../enums/event-types");
class SessionCreatedEvent {
    constructor(session) {
        this.eventType = SessionCreatedEvent.EventType;
        this.timestamp = new Date();
        this.session = session;
    }
}
exports.SessionCreatedEvent = SessionCreatedEvent;
SessionCreatedEvent.EventType = event_types_1.SessionServiceEventType.SESSION_CREATED;
